// Users domain: shared display lookups. Mock data for clients, corporates,
// drivers, and staff has been replaced by directoryApi (see src/lib/api.ts).

export type StaffLevel = 1 | 2 | 3;

export const staffLevelLabel: Record<StaffLevel, string> = {
  1: "L1 · Associate",
  2: "L2 · Lead",
  3: "L3 · Executive",
};
